<template lang="pug">
.charity-popup
  .wrapper
    close-btn(@clicked="setShowCharityPopup(false)")
    .cover
      img(src="~assets/charity.png")
    .title 公益介绍说明
    .body
      p “加油木兰”项目为全国100万的建档立卡贫困女性提供了公益捐助，截止目前，参与人数超过3100万人，所募善款超3000万，善款的90%用于被保人理赔，力求把爱心资金最大化的用到受助人身上。
      p 项目旨在为贫困地区女性送去教育、医疗保障，让她们有学可上，有病可医。助力改善贫困地区女性教育、医疗水平。
      p 您所支付的1元将作为公益款项通过支付宝以您的名义捐赠到该项目。




</template>
<script>
import CloseBtn from '@/components/wedgits/CloseBtn'
import { mapMutations } from 'vuex'
export default {
  name: 'CharityPopup',
  components: { CloseBtn },
  props: {
    title: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setShowCharityPopup']),
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.charity-popup
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  animation: fadeIn 0.5s $easeOutCubic both
  .wrapper
    width: 85%
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    position: relative
    display: flex
    align-items: center
    flex-direction: column
    .close-btn
      right: pxToRem(40)
      top: pxToRem(40)
    .cover
      width: 100%
      img
        width: 100%
        object-fit: contain
    .title
      text-align: center
      width: 100%
      //padding: pxToRem(40)
      font-size: pxToRem(36)
      color: black
      margin-bottom: pxToRem(30)
    .body
      padding: pxToRem(30)
      font-size: 12px

@keyframes fadeIn
  0%
    transform: scale(1.2)
    opacity: 0
  100%
    transform: scale(1)
    opacity: 1
</style>
